import React from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import Icon from "../Utils/Icon";
import Amount from "../Utils/Amount";

import classes from "./styles.module.css";

function TableRow({data}) {
    return (
        <tr>
            <td className={classes.CellLeft}>
                <Icon className={classes.FavoriteIcon} color="#f44336" icon="star-full" size={'12px'}/>
                {data.displayName}
            </td>

            <td>
                <a className={classes.Link} target="_blank" rel="noopener noreferrer" href={data.url}>
                    {data.url ? data.url.replace(/^([a-zA-Z]+):\/\//, '') : "-"}
                </a>
            </td>

            <td className={classes.AmountCell}>
                {data.balance.map((el, index) => {
                    const currency = Object.keys(el)[0];
                    return (
                        <span key={index}>
              <Amount amount={el[currency]} currency={currency}/>
            </span>
                    );
                })}
            </td>

            <td className={classes.AmountCell}>
                {Boolean(data.averageBill.length) ? (
                    data.averageBill.map((v, i) => {
                        const currency = Object.keys(v)[i];
                        return v[currency].payment ? (
                            <Amount key={i} currency={currency} amount={v[currency].payment.toFixed(2)}/>
                        ) : (
                            <span key={i}>—</span>
                        );
                    })
                ) : (
                    <span>—</span>
                )}
            </td>

            <td className={classes.AmountCell}>
                {Boolean(data.averageBill.length) ? (
                    data.averageBill.map((v, i) => {
                        const currency = Object.keys(v)[i];
                        return v[currency].payout ? (
                            <Amount key={i} currency={currency} amount={v[currency].payout.toFixed(2)}/>
                        ) : (
                            <span key={i}>—</span>
                        );
                    })
                ) : (
                    <span>—</span>
                )}
            </td>

            <td>
                <Link to={'/projects/settings/' + data.uuid} className={classes.Link}>
                    <Icon className={classes.SettingsIcon} color="#2479E0" icon="settings" size={'18px'}/>
                    <FormattedMessage id="ProjectsWidget.table.settings" defaultMessage="Настройки"/>
                </Link>
            </td>
        </tr>
    );
}

export default TableRow;



// WEBPACK FOOTER //
// ./src/Components/ProjectsWidget/TableRow.js